import { AlertTriangle, Lock, ShieldCheck } from "lucide-react";

const pill = "inline-flex items-center gap-1 text-[11px] font-bold px-2 py-1 rounded-full border";

// Status da licença na tabela: Ativa · Ativa (Xd) · Vence em Xd (≤7) · Expirada · Inativa.
export function LicencaBadge({ status, testId }) {
  if (!status) return <span className="text-xs text-muted-foreground" data-testid={testId}>—</span>;
  const { blocked, reason, days_remaining: d } = status;
  if (blocked && reason === "expired") {
    return <span data-testid={testId} className={`${pill} bg-rose-100 text-rose-800 border-rose-200`}><Lock className="w-3 h-3" />Expirada</span>;
  }
  if (blocked) {
    return <span data-testid={testId} className={`${pill} bg-slate-200 text-slate-800 border-slate-300`}><Lock className="w-3 h-3" />Inativa</span>;
  }
  if (typeof d === "number" && d >= 0 && d <= 7) {
    return <span data-testid={testId} className={`${pill} bg-amber-100 text-amber-800 border-amber-200`}><AlertTriangle className="w-3 h-3" />Vence em {d}d</span>;
  }
  const label = typeof d === "number" ? `Ativa (${d}d)` : "Ativa";
  return <span data-testid={testId} className={`${pill} bg-emerald-100 text-emerald-800 border-emerald-200`}><ShieldCheck className="w-3 h-3" />{label}</span>;
}
